import React, { useState, useEffect } from "react";
import { apiFetch } from "../lib/api";
import { FolderGit2 } from "lucide-react";

export default function DocumentControl() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadData = async () => {
    try {
      setLoading(true);
      const res = await apiFetch("/document-control");
      if (res?.ok) setItems(res.items || []);
    } catch {
      // Fallback
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadData(); }, []);

  return (
    <div className="space-y-4" id="document-control-page" data-testid="document-control-page">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-xl font-bold text-[#082B4D] flex items-center gap-2">
            <FolderGit2 className="w-5 h-5 text-[#18B84F]" />
            Document Control Register (Controlled Distribution & Revisions)
          </h1>
          <p className="text-xs text-slate-500">ISO policies, procedures, work instructions, read acknowledgements & change summaries</p>
        </div>
      </div>

      <div className="bg-white rounded-lg border border-slate-200 shadow-sm overflow-hidden text-xs">
        <table className="w-full text-left border-collapse">
          <thead className="bg-slate-50 border-b border-slate-200 text-slate-600 font-semibold uppercase text-[10px]">
            <tr>
              <th className="p-3">Doc No</th>
              <th className="p-3">Title</th>
              <th className="p-3">Category</th>
              <th className="p-3">Revision</th>
              <th className="p-3">Status</th>
              <th className="p-3">Effective Date</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100 font-mono">
            {loading ? (
              <tr><td colSpan="6" className="p-4 text-center text-slate-400">Loading documents...</td></tr>
            ) : items.length === 0 ? (
              <tr><td colSpan="6" className="p-4 text-center text-slate-400">No controlled documents found.</td></tr>
            ) : (
              items.map((r) => (
                <tr key={r.id} className="hover:bg-slate-50">
                  <td className="p-3 font-bold text-blue-600">{r.document_number}</td>
                  <td className="p-3 font-sans font-medium text-slate-800">{r.title}</td>
                  <td className="p-3 uppercase text-[10px]">{r.category}</td>
                  <td className="p-3">{r.revision}</td>
                  <td className="p-3"><span className="px-2 py-0.5 rounded bg-slate-100 text-slate-700 font-sans uppercase text-[9px] font-bold">{r.status}</span></td>
                  <td className="p-3 text-slate-500">{r.effective_date}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
